"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-breadcrumb-container {\n  list-style-type: none;\n  text-align: left;\n  margin: 0;\n  padding: 0; }\n\n.bds-breadcrumb-item {\n  display: inline-block;\n  font-size: 0.875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02813rem;\n  font-weight: 400;\n  cursor: pointer; }\n\n.bds-breadcrumb-item,\n.bds-breadcrumb-item a,\n.bds-breadcrumb-item a:visited,\n.bds-breadcrumb-item a:focus,\n.bds-breadcrumb-item a:hover {\n  text-decoration: none;\n  color: #067fdb; }\n\n.bds-breadcrumb-item a:hover,\n.bds-breadcrumb-item span:hover {\n  text-decoration: underline; }\n\n.bds-breadcrumb-item-separator,\n.bds-breadcrumb-item-last a,\n.bds-breadcrumb-item-last a:visited,\n.bds-breadcrumb-item-last a:focus,\n.bds-breadcrumb-item-last a:hover {\n  text-decoration: none;\n  color: #161616; }\n\n.bds-breadcrumb-item-separator {\n  margin: 0 1rem; }\n\n.bds-breadcrumb-item span:nth-child(2):hover {\n  text-decoration: none; }\n\n.bds-breadcrumb-overflow-item {\n  color: #067fdb; }\n";
  var fileName = "compone_breadcrumb";
  var element = document.querySelector("style[data-sass-component='compone_breadcrumb']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var renderBreadcrumbCompressed = function renderBreadcrumbCompressed(_ref) {
  var history = _ref.history,
      routeToNameList = _ref.routeToNameList,
      expansionHandlder = _ref.expansionHandlder;
  var firstItem = routeToNameList[0];
  var lastItem = routeToNameList[routeToNameList.length - 1];
  return /*#__PURE__*/_react.default.createElement("ul", {
    role: _constants.listRole,
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement(BreadcrumbItem, {
    route: firstItem.route,
    name: firstItem.name,
    href: firstItem.href,
    key: "".concat(_constants.keyPrefix, "0"),
    history: history
  }), /*#__PURE__*/_react.default.createElement(BreadcrumbItem, {
    overflowItem: true,
    expansionHandlder: expansionHandlder,
    key: "".concat(_constants.keyPrefix, "1")
  }), /*#__PURE__*/_react.default.createElement(BreadcrumbItem, {
    route: lastItem.route,
    name: lastItem.name,
    href: lastItem.href,
    isLastItem: true,
    key: "".concat(_constants.keyPrefix, "2"),
    history: history
  }));
};

var renderBreadcrumbExpander = function renderBreadcrumbExpander(_ref2) {
  var history = _ref2.history,
      routeToNameList = _ref2.routeToNameList;
  return /*#__PURE__*/_react.default.createElement("ul", {
    role: _constants.listRole,
    className: _constants.classes.container
  }, routeToNameList && routeToNameList.map(function (element, index) {
    var route = element.route,
        name = element.name,
        href = element.href;
    var isLastItem = index === routeToNameList.length - 1;
    var allProps = {
      route: route,
      name: name,
      isLastItem: isLastItem,
      href: href,
      history: history
    };
    return /*#__PURE__*/_react.default.createElement(BreadcrumbItem, _extends({
      key: "".concat(_constants.keyPrefix).concat(index)
    }, allProps));
  }));
};

var Breadcrumb = function Breadcrumb(_ref3) {
  var routeToNameList = _ref3.routeToNameList,
      history = _ref3.history;

  var _useState = (0, _react.useState)(routeToNameList.length > _constants.defaultLength),
      _useState2 = _slicedToArray(_useState, 2),
      isCompressed = _useState2[0],
      setIsCompressed = _useState2[1];

  var expansionHandlder = function expansionHandlder() {
    setIsCompressed(false);
  };

  return isCompressed ? renderBreadcrumbCompressed({
    routeToNameList: routeToNameList,
    expansionHandlder: expansionHandlder,
    history: history
  }) : renderBreadcrumbExpander({
    routeToNameList: routeToNameList,
    history: history
  });
};

var BreadcrumbItem = function BreadcrumbItem(_ref4) {
  var _breadcrumbItemClasse;

  var history = _ref4.history,
      href = _ref4.href,
      route = _ref4.route,
      name = _ref4.name,
      isLastItem = _ref4.isLastItem,
      expansionHandlder = _ref4.expansionHandlder,
      overflowItem = _ref4.overflowItem;
  var breadcrumbItemClasses = (_breadcrumbItemClasse = {}, _defineProperty(_breadcrumbItemClasse, _constants.classes.item, true), _defineProperty(_breadcrumbItemClasse, _constants.classes.lastItem, isLastItem), _breadcrumbItemClasse);

  var clickHandler = function clickHandler(event) {
    !href && event.preventDefault();
    !href && history && route && history.push(route);
  };

  return !overflowItem ? /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)(breadcrumbItemClasses),
    tabIndex: _constants.tabIndex
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    onClick: clickHandler,
    target: _constants.target
  }, name), !isLastItem && /*#__PURE__*/_react.default.createElement("span", {
    className: _constants.classes.separator
  }, "/")) : /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)(breadcrumbItemClasses),
    onClick: function onClick() {
      return expansionHandlder();
    },
    tabIndex: _constants.tabIndex
  }, /*#__PURE__*/_react.default.createElement("span", null, "..."), /*#__PURE__*/_react.default.createElement("span", {
    className: _constants.classes.separator
  }, "/"));
};

Breadcrumb.propTypes = {
  routeToNameList: _propTypes.default.arrayOf(_propTypes.default.shape({
    route: _propTypes.default.string,
    name: _propTypes.default.string.isRequired
  }).isRequired)
};
var _default = Breadcrumb;
exports.default = _default;